export type ProgramManagementDataPropertyModel = Record<string, boolean>;

export class ProgramManagementDataPropertiesModel {
	[key: string]: ProgramManagementDataPropertyModel;
}

export function ProgramManagementDataPropertiesModel_ClassTransform_Type() {
	return ProgramManagementDataPropertiesModel;
}

export class ProgramManagementPropertiesFullModel {
	group: string;
	key: string;
	local_value: boolean | null;
	local_value_exists: boolean;
	tree_value: boolean | null;
	value: boolean | null;
}

export function ProgramManagementPropertiesFullModel_ClassTransform_Type() {
	return ProgramManagementPropertiesFullModel;
}
